<template>
    <aside class="sidebar">
        <section>
            <h5 class="sidebar__cat" :class="{ '--active': atleast_step(1) }">
                1. Lifestyle
            </h5>
            <transition name="fade">
                <p v-show="life_style">{{ life_style | capitalize }}</p>
            </transition>
        </section>

        <section>
            <h5 class="sidebar__cat" :class="{ '--active': atleast_step(2) }">
                2. Skin Type
            </h5>
            <transition name="fade">
                <p v-show="skin_type">{{ skin_type | capitalize }}</p>
            </transition>
        </section>

        <section>
            <h5 class="sidebar__cat" :class="{ '--active': atleast_step(3) }">
                3. Skin Concern
            </h5>
            <transition name="fade">
                <p v-show="skin_concern">{{ skin_concern | capitalize }}</p>
            </transition>
        </section>

        <section>
            <h5 class="sidebar__cat" :class="{ '--active': atleast_step(4) }">
                4. Preferred Benefit
            </h5>
            <transition name="fade">
                <p v-show="preferred_benefit">{{ preferred_benefit | capitalize }}</p>
            </transition>
        </section>
    </aside>
</template>

<script>
import { bus } from '../utilities'
import logic from '../data/logic'

export default {
    name: 'AnswerSidebar',
    filters: {
        capitalize(string) {
            if (typeof string !== 'string') {
                return string
            }

            return string.charAt(0)
                .toUpperCase()
                .concat(string.slice(1))
        },
    },
    data() {
        return {
            answers: {
                life_style: null,
                skin_type: null,
                skin_concern: null,
                preferred_benefit: null,
            },
        }
    },
    computed: {
        life_style() {
            const which = this.answers.life_style === null
                ? this.$route.params.life_style
                : this.answers.life_style

            return logic.quiz[2].options[which]
        },
        skin_type() {
            const which = this.answers.skin_type === null
                ? this.$route.params.skin_type
                : this.answers.skin_type

            return logic.quiz[3].options[which]
        },
        skin_concern() {
            const concerns_from_url = this.$route.params.skin_concern ? this.$route.params.skin_concern.split(',') : []
            const concerns = this.answers.skin_concern === null
                ? concerns_from_url
                : this.answers.skin_concern.split(',')

            return concerns.map((c) => {
                // In case anyone tries to monkey around with this list
                if (typeof logic.quiz[4].options[c] !== 'undefined') {
                    return logic.quiz[4].options[c]
                }

                return bus.$emit('next', '/')
            }).join(', ')
        },
        preferred_benefit() {
            const which = this.answers.preferred_benefit === null
                ? this.$route.params.benefit
                : this.answers.preferred_benefit

            return logic.quiz[5].options[which]
        },
    },
    created() {
        bus.$on('answer::chosen', (answer) => {
            switch (this.$route.name) {
                case 'life-style':
                    this.answers.life_style = answer
                    break
                case 'skin-type':
                    this.answers.skin_type = answer
                    break
                case 'skin-concerns':
                    this.answers.skin_concern = answer
                    break
                case 'preferred-benefit':
                    this.answers.preferred_benefit = answer
                    break
                default:
                    break
            }
        })
        bus.$on('navigate::back', () => {
            switch (this.$route.name) {
                case 'preferred-benefit':
                    this.answers.preferred_benefit = null
                    break
                case 'skin-concerns':
                    this.answers.preferred_benefit = null
                    this.answers.skin_concern = null
                    break
                case 'skin-type':
                    this.answers.preferred_benefit = null
                    this.answers.skin_concern = null
                    this.answers.skin_type = null
                    break
                case 'life-style':
                    this.answers.preferred_benefit = null
                    this.answers.skin_concern = null
                    this.answers.skin_type = null
                    this.answers.life_style = null
                    break
                default:
                    break
            }
        })
    },
    methods: {
        atleast_step(step) {
            switch (step) {
                case 1:
                    return this.$route.params.age
                case 2:
                    return this.$route.params.life_style
                case 3:
                    return this.$route.params.skin_type
                case 4:
                    return this.$route.params.skin_concern
                default:
                    return false
            }
        },
    },
}
</script>


// WEBPACK FOOTER //
// source/app/js/components/sidebar.vue